import client from '@/api/client.js';
//import i18n from '@/plugins/i18n.js';
import store from "@/store";

export default {
    methods: {
        async getExportView() {
            var meta = {
                clientApiMethod: 'getExportView',
                input: { },
            }
            var response = await client()
                .get(store.state.apiRouteRoot + "Export/", { meta: meta });
            return response.data;
        },

        async getExportFile(fileReuqestParams) {
            var meta = {
                clientApiMethod: 'getExportFile',
                input: { fileReuqestParams: fileReuqestParams },
            }
            var response = await client()
                .get(store.state.apiRouteRoot + "Export/File", { params: fileReuqestParams, meta: meta, responseType: 'arraybuffer' });
            return response;
        },

         async deleteExportFiles(date) {
            var meta = {
                clientApiMethod: 'deleteExportFiles',
                input: { date: date },
            }
            var response = await client()
                .delete(store.state.apiRouteRoot + "Export/?displayedExportDate=" + date, { meta: meta });
            return response.data;
        },
    }
}